import BaseApi from "./BaseApi";
import qs from "qs";

export const getRegionResults = async reqObj => {
  const reqStr = qs.stringify(reqObj, { allowDots: true, encode: false });
  const result = await BaseApi.get(
    `/reservationProcess/RegionResultsR?${reqStr}`
  );
  return result;
};

// export const redirectToHotelSearchResultsPage = (selectedSessions, hotelId) => {
//     let query = `hotelId=${hotelId}`;
//     for (let i = 0; i < selectedSessions.length; i++) {
//         const encodedSession = encodeURIComponent(selectedSessions[i]);
//         query += `&sessions[${i}]=${encodedSession}`;
//     }
//     window.location = `${serverURL}/reservationProcess/?${query}`;
// };



// WEBPACK FOOTER //
// ./src/api/regions.js